<template>
  <div class="container-innovadores">
      <div class="container container-fade">
        <div class="row align-self-center">
          <div class="col-12 col-md-6 align-self-center">
            <div class="row">

              <div class="col-12 col-md-5 offset-md-1 align-self-center d-block d-md-none">
                <div class="text-center">
                  <img width="80%" :src="`${publicPath}assets/images/innovadores.png`" />
                </div>
              </div>

              
              <div class="col-12 ">
                <div class="linea mt-3 pb-3 mb-3">
                  <h2>{{ article.story.innovadores.title }}</h2>
                </div>  
                <div v-html="article.story.innovadores.descripcion"></div>              

                <div class="text-center linea">
                </div>                
              </div>

            </div>
          </div>

          <div class="col-12 col-md-4 offset-md-1 align-self-center d-none d-md-block text-right">
            <div>
              <img width="100%" :src="`${publicPath}assets/images/innovadores.png`" />
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 col-md-8">
            <NominadosList :nominados="nominados" />
          </div>          
        </div>
      </div>      
    </div>
</template>

<script>

import filter from 'lodash/filter'

import NominadosList from '@/components/NominadosList'

export default {
  name: 'Innovadores',
  props: {
    nominados_list: []
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  components: {
    NominadosList
  },
  computed: {
    article() {
      return require(`@/i18n/es.json`)
    },
    nominados() {
      return filter(this.nominados_list, ['category_id', 'innovadores'])
    }
  }
}
</script>
